export const msToHoursMinutes = (ms) => {
  const hours = Math.floor(ms / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  return { hours, minutes };
};

export const hoursMinutesToMs = (hours, minutes) => parseFloat(hours) * 3600000 + parseFloat(minutes) * 60000;
